import React from "react";
import { Grid } from "@material-ui/core";

import { IWithballData } from "types";

import { TouchBallBoard } from "components/TouchBallBoard";

interface ITouchBallPanelPanel {
  dataArray: IWithballData[];
}

export const TouchBallPanel = ({ dataArray }: ITouchBallPanelPanel) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6} lg={4}>
        <TouchBallBoard dataArray={dataArray} />
      </Grid>
    </Grid>
  );
};
